(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var form = document.getElementById('BbCartForm');
    if (!form || form.dataset.init) return;
    form.dataset.init = '1';
    form.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-cart-dec]');
      var inc = e.target.closest('[data-cart-inc]');
      if (!dec && !inc) return;
      var row = e.target.closest('.bb-cartpage__row');
      var input = row ? row.querySelector('[data-cart-qty]') : null;
      if (!input) return;
      var qty = parseInt(input.value || '1', 10);
      input.value = dec ? Math.max(0, qty - 1) : qty + 1;
      form.requestSubmit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(sectionId) {
      var root = document.getElementById('BbProduct-' + sectionId);
      if (!root || root.dataset.init) return;
      root.dataset.init = '1';
      var dataEl = document.getElementById('BbVariants-' + sectionId);
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var mediaMap = {};
      try { mediaMap = JSON.parse(document.getElementById('BbVariantMedia-' + sectionId).textContent) || {}; } catch (e) { mediaMap = {}; }
      var colorMedia = {};
      try { colorMedia = JSON.parse(document.getElementById('BbColorMedia-' + sectionId).textContent) || {}; } catch (e) { colorMedia = {}; }
      // Server-formatted prices (correct currency/symbol/decimals). Falls back to fmt only if missing.
      var moneyMap = {};
      try { moneyMap = JSON.parse(document.getElementById('BbVariantMoney-' + sectionId).textContent) || {}; } catch (e) { moneyMap = {}; }
      var colorKey = 'option' + (root.getAttribute('data-color-pos') || '1');
      var sizeKey = 'option' + (root.getAttribute('data-size-pos') || '2');
      var currentId = root.getAttribute('data-current-id');
      var selected =
        variants.find(function (v) { return String(v.id) === String(currentId); }) ||
        variants.find(function (v) { return v.available; }) ||
        variants[0];
      var state = { color: null, size: null };
      if (selected) {
        state.color = selected[colorKey];
        state.size = selected[sizeKey];
      }

      function findVariant() {
        return variants.find(function (v) {
          var okColor = !state.color || v[colorKey] === state.color;
          var okSize = !state.size || v[sizeKey] === state.size;
          return okColor && okSize;
        });
      }
      function fmt(cents) { return '$' + (cents / 100).toFixed(2); }
      function moneyFor(v) {
        var m = moneyMap[String(v.id)] || {};
        return {
          price: m.price || fmt(v.price),
          compare: m.compare || (v.compare_at_price ? fmt(v.compare_at_price) : '')
        };
      }
      function render() {
        selected = findVariant() || selected;
        if (!selected) return;
        var idInput = root.querySelector('[data-bb-variant-id]');
        if (idInput) idInput.value = selected.id;
        var mv = moneyFor(selected);
        root.querySelectorAll('[data-bb-price]').forEach(function (el) { el.textContent = mv.price; });
        root.querySelectorAll('[data-bb-atc-price]').forEach(function (el) { el.textContent = mv.price; });
        var cmp = root.querySelector('[data-bb-compare]');
        var dmap = moneyMap[String(selected.id)] || {};
        var dcr = dmap.dcompare_raw != null ? dmap.dcompare_raw : selected.compare_at_price;
        if (cmp) {
          if (dcr > selected.price && mv.compare) {
            cmp.hidden = false;
            cmp.textContent = mv.compare;
          } else { cmp.hidden = true; }
        }
        var sticky = document.getElementById('BbStickyAtc');
        if (sticky) {
          var sp = sticky.querySelector('[data-bb-atc-price]');
          if (sp) sp.textContent = mv.price;
        }
        var savePill = root.querySelector('[data-bb-save]');
        if (savePill) savePill.hidden = !(dcr > selected.price);
        var cn = root.querySelector('[data-bb-color-name]');
        if (cn && selected[colorKey]) cn.textContent = selected[colorKey];
        var sn = root.querySelector('[data-bb-size-name]');
        if (sn && selected[sizeKey]) sn.textContent = selected[sizeKey];
        var btn = root.querySelector('[data-bb-add]');
        if (btn) {
          btn.disabled = !selected.available;
          btn.firstChild.textContent = selected.available ? 'Add to cart - ' : 'Sold out ';
        }
        updateGallery();
      }
      root.querySelectorAll('[data-bb-option]').forEach(function (group) {
        var which = group.getAttribute('data-bb-option');
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            group.querySelectorAll('[data-value]').forEach(function (b) {
              b.classList.remove('is-active');
              b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('is-active');
            btn.setAttribute('aria-checked', 'true');
            if (which === 'color') state.color = btn.getAttribute('data-value');
            else state.size = btn.getAttribute('data-value');
            render();
          });
        });
      });

      // Thumbnails
      var main = root.querySelector('#BbMainImage-' + sectionId);
      function updateGallery() {
        if (!main || !selected) return;
        var color = selected[colorKey];
        var set = color && colorMedia[color] && colorMedia[color].length ? colorMedia[color] : null;
        var specific = mediaMap[String(selected.id)] || null;
        var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-bb-thumb]'));
        if (!thumbs.length) return;
        if (!set && !specific) {
          thumbs.forEach(function (t) { t.style.display = ''; });
          return;
        }
        // Photos attached to ANY color variant. Everything else is generic
        // (lifestyle, description images) and stays visible for every color.
        var attached = {};
        Object.keys(colorMedia).forEach(function (c) {
          (colorMedia[c] || []).forEach(function (u) { attached[u] = true; });
        });
        var byUrl = {};
        thumbs.forEach(function (t) { byUrl[t.getAttribute('data-bb-thumb')] = t; });
        // Order: variant photo first, then this color's photos, then generic ones.
        var ordered = [];
        var seen = {};
        function push(url) {
          var t = byUrl[url];
          if (t && !seen[url]) {
            seen[url] = true;
            ordered.push(t);
          }
        }
        if (specific) push(specific);
        if (set) set.forEach(push);
        thumbs.forEach(function (t) {
          var url = t.getAttribute('data-bb-thumb');
          if (!attached[url]) push(url);
        });
        var strip = thumbs[0].parentNode;
        ordered.forEach(function (t) {
          t.style.display = '';
          t.classList.remove('is-active');
          strip.appendChild(t);
        });
        thumbs.forEach(function (t) {
          if (ordered.indexOf(t) === -1) {
            t.style.display = 'none';
            t.classList.remove('is-active');
            strip.appendChild(t);
          }
        });
        if (ordered[0]) ordered[0].classList.add('is-active');
        var target = specific || (set && set[0]);
        if (target && main.getAttribute('src') !== target) main.src = target;
      }
      root.querySelectorAll('[data-bb-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          root.querySelectorAll('[data-bb-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (main) {
            main.src = t.getAttribute('data-bb-thumb');
            main.alt = t.getAttribute('data-bb-alt') || '';
          }
        });
      });

      // Qty stepper
      var qty = root.querySelector('[data-bb-qty]');
      var dec = root.querySelector('[data-bb-qty-dec]');
      var inc = root.querySelector('[data-bb-qty-inc]');
      if (dec && qty) dec.addEventListener('click', function () { qty.value = Math.max(1, parseInt(qty.value || '1', 10) - 1); });
      if (inc && qty) inc.addEventListener('click', function () { qty.value = parseInt(qty.value || '1', 10) + 1; });

      // Sticky bar visibility
      var buybox = root.querySelector('#BbBuyBox');
      var sticky = document.getElementById('BbStickyAtc');
      if (buybox && sticky && 'IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.hidden = !past;
        }, { threshold: 0 });
        obs.observe(buybox);
      }
      var stickyBtn = sticky ? sticky.querySelector('[data-bb-sticky-add]') : null;
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var form = root.querySelector('[data-bb-product-form]');
          if (form) form.requestSubmit();
        });
      }
      render();
    }
    document.querySelectorAll('[id^="BbProduct-"]').forEach(function (el) {
      init(el.id.replace('BbProduct-', ''));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
